import { Injectable } from '@angular/core'
import { DataService } from '@vendure/admin-ui/core'

import { GetNextAddressStatesDocument, TransitionAddressToStateDocument } from '../generated/ui-types'

@Injectable()
export class AddressStateDataService {
    constructor(private dataService: DataService) {}

    getNextStates(id: string) {
        return this.dataService.query(GetNextAddressStatesDocument, {
            id,
        })
    }

    transitionToState(id: string, state: string) {
        return this.dataService.mutate(TransitionAddressToStateDocument, {
            id,
            state,
        })
    }
}
